export default __webpack_public_path__ + "static/media/15.5d9ea89f.jpg";